// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.countdown {\n  font-size: 12px;\n  padding: 0 0.2rem;\n  box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;\n}\n.time {\n  font-weight: bold;\n  color: #CE5F3A;\n}\n", ""]);
// Exports
module.exports = exports;
